export default __webpack_public_path__ + "src/assets/rep-logo.6e9c54643cf7b30237fd8f82d54a8f1a.svg";